import React, { useState, useEffect, useRef } from 'react';

// NOT: Resimlerin projenizde src/assets klasöründe olduğundan emin olun.
import desktopLogo from './assets/logo.png'; 
import mobileLogo from './assets/logo_.png';

// --- ICONS (SVG) ---
const Icon = ({ children, className, size = 24, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} {...props}>
    {children}
  </svg>
);

const Icons = {
  Menu: (p) => <Icon {...p}><line x1="4" y1="12" x2="20" y2="12" /><line x1="4" y1="6" x2="20" y2="6" /><line x1="4" y1="18" x2="20" y2="18" /></Icon>,
  X: (p) => <Icon {...p}><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></Icon>,
  ChevronUp: (p) => <Icon {...p}><polyline points="18 15 12 9 6 15" /></Icon>,
  ChevronRight: (p) => <Icon {...p}><polyline points="9 18 15 12 9 6" /></Icon>,
  ArrowRight: (p) => <Icon {...p}><line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" /></Icon>,
  ArrowLeft: (p) => <Icon {...p}><line x1="19" y1="12" x2="5" y2="12" /><polyline points="12 19 5 12 12 5" /></Icon>,
  Code: (p) => <Icon {...p}><polyline points="16 18 22 12 16 6" /><polyline points="8 6 2 12 8 18" /></Icon>,
  Smartphone: (p) => <Icon {...p}><rect x="5" y="2" width="14" height="20" rx="2" ry="2" /><path d="M12 18h.01" /></Icon>,
  ShieldCheck: (p) => <Icon {...p}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /><path d="m9 12 2 2 4-4" /></Icon>,
  Cpu: (p) => <Icon {...p}><rect x="4" y="4" width="16" height="16" rx="2" ry="2" /><rect x="9" y="9" width="6" height="6" /><path d="M9 1h6" /><path d="M9 23h6" /><path d="M1 9v6" /><path d="M23 9v6" /></Icon>,
  Network: (p) => <Icon {...p}><rect x="16" y="16" width="6" height="6" rx="1" /><rect x="2" y="16" width="6" height="6" rx="1" /><rect x="9" y="2" width="6" height="6" rx="1" /><path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3" /><path d="M12 12V8" /></Icon>,
  Palette: (p) => <Icon {...p}><path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12c0 .66.08 1.32.2 2 .7 3.3 3.6 5.8 7.3 5.8 1.1 0 2-.9 2-2 0-.28-.06-.55-.16-.8 0 0 .5-.5 1.46-.5 1.4 0 2.5 1.1 2.5 2.5V22z" /><circle cx="12" cy="7" r="1" /><circle cx="7" cy="11" r="1" /><circle cx="17" cy="11" r="1" /><circle cx="12" cy="17" r="1" /></Icon>,
  Facebook: (p) => <Icon {...p}><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" /></Icon>,
  Twitter: (p) => <Icon {...p}><path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z" /></Icon>,
  Instagram: (p) => <Icon {...p}><rect x="2" y="2" width="20" height="20" rx="5" ry="5" /><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" /><line x1="17.5" y1="6.5" x2="17.51" y2="6.5" /></Icon>,
  Linkedin: (p) => <Icon {...p}><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" /><rect x="2" y="9" width="4" height="12" /><circle cx="4" cy="4" r="2" /></Icon>,
  Mail: (p) => <Icon {...p}><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" /></Icon>,
  MapPin: (p) => <Icon {...p}><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" /></Icon>,
  Phone: (p) => <Icon {...p}><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" /></Icon>,
  MessageSquare: (p) => <Icon {...p}><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></Icon>,
  Target: (p) => <Icon {...p}><circle cx="12" cy="12" r="10" /><circle cx="12" cy="12" r="6" /><circle cx="12" cy="12" r="2" /></Icon>,
  Zap: (p) => <Icon {...p}><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" /></Icon>,
  Users: (p) => <Icon {...p}><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></Icon>,
  Headset: (p) => <Icon {...p}><path d="M3 18v-6a9 9 0 0 1 18 0v6" /><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" /></Icon>,
  Lock: (p) => <Icon {...p}><rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></Icon>,
  CheckCircle: (p) => <Icon {...p}><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" /></Icon>,
  Quote: (p) => <Icon {...p}><path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z" /><path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z" /></Icon>,
  QuoteSolid: (p) => <Icon {...p} viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M14.017 21L14.017 18C14.017 16.8954 14.9124 16 16.017 16H19.017C19.5693 16 20.017 15.5523 20.017 15V9C20.017 8.44772 19.5693 8 19.017 8H15.017C14.4647 8 14.017 7.55228 14.017 7V3H19.017C20.6739 3 22.017 4.34315 22.017 6V15C22.017 18.3137 19.3307 21 16.017 21H14.017ZM5.0166 21L5.0166 18C5.0166 16.8954 5.91203 16 7.0166 16H10.0166C10.5689 16 11.0166 15.5523 11.0166 15V9C11.0166 8.44772 10.5689 8 10.0166 8H6.0166C5.46432 8 5.0166 7.55228 5.0166 7V3H10.0166C11.6735 3 13.0166 4.34315 13.0166 6V15C13.0166 18.3137 10.3303 21 7.0166 21H5.0166Z" /></Icon>
};

// --- CUSTOM HOOKS ---
function useOnScreen(ref, rootMargin = "0px") {
  const [isIntersecting, setIsIntersecting] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsIntersecting(true);
          observer.unobserve(entry.target);
        }
      },
      { rootMargin }
    );
    if (ref.current) observer.observe(ref.current);
    return () => {
      if (ref.current) observer.unobserve(ref.current);
    };
  }, [ref, rootMargin]);
  return isIntersecting;
}

// --- ANIMATION COMPONENTS ---

const FadeInSection = ({ children, delay = 0 }) => {
  const ref = useRef();
  const isVisible = useOnScreen(ref, "-50px");

  return (
    <div
      ref={ref}
      className={`transition-all duration-1000 transform ${
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
      }`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
};

const CountUpAnimation = ({ end, duration = 2000, suffix = "" }) => {
  const [count, setCount] = useState(0);
  const ref = useRef();
  const onScreen = useOnScreen(ref);
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    if (onScreen && !hasAnimated) {
      let startTimestamp = null;
      const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        setCount(Math.floor(progress * end));
        if (progress < 1) {
          window.requestAnimationFrame(step);
        } else {
          setHasAnimated(true);
        }
      };
      window.requestAnimationFrame(step);
    }
  }, [onScreen, end, duration, hasAnimated]);

  return <span ref={ref}>{count}{suffix}</span>;
};

// --- MAIN SECTIONS ---

const Navbar = ({ scrollToContact }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Ana Sayfa', href: '#home' },
    { name: 'Hakkımızda', href: '#about-us' },
    { name: 'Hizmetler', href: '#services' },
    { name: 'Referanslar', href: '#testimonials' },
  ];

  return (
    <nav className={`fixed top-0 left-0 w-full z-50 transition-colors duration-300 h-20 flex items-center ${
      isScrolled ? 'bg-white/95 backdrop-blur-md border-b border-gray-100 shadow-sm' : 'bg-transparent'
    }`}>
      <div className="container mx-auto px-6 flex justify-between items-center w-full">
        <a href="#" className="flex items-center gap-2 group">
          {/* Logo Container */}
          <div className="h-10 w-auto relative flex items-center justify-center">
             {/* Desktop Logo */}
             <img src={desktopLogo} alt="AA Yazılım" className="hidden md:block h-full w-auto object-contain" />
             {/* Mobile Logo */}
             <img src={mobileLogo} alt="AA Yazılım" className="md:hidden h-full w-auto object-contain" />
          </div>
        </a>

        <div className="hidden md:flex items-center space-x-8">
          {navLinks.map((link) => (
            <a key={link.name} href={link.href} className="text-gray-600 hover:text-[#a41018] transition-colors text-sm font-semibold tracking-wide relative group">
              {link.name}
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#a41018] transition-all group-hover:w-full"></span>
            </a>
          ))}
        </div>

        <button className="md:hidden text-gray-800 p-2" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <Icons.X size={28} /> : <Icons.Menu size={28} />}
        </button>
      </div>

      <div className={`md:hidden absolute top-20 left-0 w-full bg-white border-b border-gray-100 transition-all duration-300 overflow-hidden shadow-xl ${
        isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
      }`}>
        <div className="flex flex-col p-6 space-y-4">
          {navLinks.map((link) => (
            <a key={link.name} href={link.href} onClick={() => setIsOpen(false)} className="text-gray-700 hover:text-[#a41018] text-lg font-medium border-b border-gray-50 pb-2">
              {link.name}
            </a>
          ))}
        </div>
      </div>
    </nav>
  );
};

const Hero = ({ scrollToContact }) => {
  return (
    <section id="home" className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-white">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-red-50/50 skew-x-12 translate-x-32 z-0"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#a41018]/5 rounded-full blur-3xl z-0"></div>

      <div className="container mx-auto px-6 relative z-10 grid md:grid-cols-2 gap-16 items-center">
        <div className="space-y-8">
          <FadeInSection>
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#a41018]/5 border border-[#a41018]/10 rounded-full text-[#a41018] text-sm font-semibold mb-6 animate-fade-in">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#a41018] opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-[#a41018]"></span>
              </span>
              Dijital Dönüşüm Başlıyor
            </div>
            <h1 className="text-4xl md:text-6xl font-extrabold text-gray-900 leading-tight">
              Geleceği Kodluyoruz, <br />
              <span className="text-[#a41018]">Başarınızı İnşa Ediyoruz</span>
            </h1>
          </FadeInSection>
          
          <FadeInSection delay={200}>
            <p className="text-gray-600 text-lg md:text-xl max-w-lg leading-relaxed">
              Web'den mobil uygulamaya, siber güvenlikten yapay zeka çözümlerine kadar işletmenizin ihtiyaç duyduğu profesyonel yazılım çözümleri.
            </p>
          </FadeInSection>

          <FadeInSection delay={400}>
            <div className="flex flex-wrap gap-4">
              <button 
                onClick={scrollToContact}
                className="px-8 py-4 bg-[#a41018] text-white font-bold rounded-xl hover:bg-[#8a0d14] transition-all duration-300 transform hover:-translate-y-1 shadow-lg hover:shadow-[#a41018]/25 flex items-center gap-2"
              >
                Projeyi Başlat <Icons.ArrowRight size={20} />
              </button>
              <a 
                href="#services"
                className="px-8 py-4 bg-white border border-gray-200 text-gray-700 font-medium rounded-xl hover:border-[#a41018] hover:text-[#a41018] transition-all duration-300 flex items-center gap-2 shadow-sm hover:shadow-md"
              >
                Hizmetleri İncele
              </a>
            </div>
          </FadeInSection>
        </div>

        <div className="relative hidden md:block">
           <FadeInSection delay={300}>
              <div className="relative z-10 rounded-2xl overflow-hidden border border-gray-200 shadow-2xl group">
                <img 
                  src="https://images.unsplash.com/photo-1497215728101-856f4ea42174?q=80&w=2070&auto=format&fit=crop" 
                  alt="Modern Office" 
                  className="w-full h-auto object-cover transform group-hover:scale-105 transition-transform duration-1000"
                />
              </div>
              
              <div className="absolute -top-6 -right-6 bg-white p-5 rounded-xl border border-gray-100 shadow-xl animate-bounce-slow flex items-center gap-3 z-20">
                <div className="bg-[#a41018]/10 p-2 rounded-lg">
                  <Icons.Code className="text-[#a41018]" size={24} />
                </div>
                <div>
                  <p className="text-xs text-gray-500">Temiz Kod</p>
                  <p className="text-sm font-bold text-gray-800">%100 Optimize</p>
                </div>
              </div>

              <div className="absolute -bottom-8 -left-8 bg-white p-5 rounded-xl border border-gray-100 shadow-xl animate-bounce-slow z-20" style={{ animationDelay: '1s' }}>
                <div className="flex items-center gap-3">
                  <div className="bg-green-100 p-2 rounded-lg">
                    <Icons.ShieldCheck className="text-green-600" size={24} />
                  </div>
                   <div>
                    <p className="text-xs text-gray-500">Güvenlik</p>
                    <p className="text-sm font-bold text-gray-800">Kurumsal Seviye</p>
                  </div>
                </div>
              </div>
           </FadeInSection>
        </div>
      </div>
    </section>
  );
};

const Stats = () => {
  return (
    <section className="py-16 bg-white border-b border-gray-100">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 divide-x divide-gray-100">
          {[
            { number: 150, suffix: "+", label: "Tamamlanan Proje" },
            { number: 50, suffix: "+", label: "Mutlu Müşteri" },
            { number: 98, suffix: "%", label: "Müşteri Memnuniyeti" },
            { number: 7, suffix: "/24", label: "Teknik Destek" }
          ].map((stat, index) => (
            <FadeInSection key={index} delay={index * 100}>
              <div className="text-center px-4 hover:-translate-y-1 transition-transform duration-300">
                <h3 className="text-4xl md:text-5xl font-bold text-[#a41018] mb-2 font-sans tracking-tight">
                  <CountUpAnimation end={stat.number} suffix={stat.suffix} />
                </h3>
                <p className="text-gray-500 font-medium text-sm">{stat.label}</p>
              </div>
            </FadeInSection>
          ))}
        </div>
      </div>
    </section>
  );
};

const AboutUs = () => {
  return (
    <section id="about-us" className="py-24 bg-white relative">
      <div className="container mx-auto px-6 grid md:grid-cols-2 gap-16 items-center">
        <FadeInSection>
          <div className="relative rounded-2xl overflow-hidden shadow-2xl group">
            <img 
              src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?q=80&w=2070&auto=format&fit=crop" 
              alt="Our Team" 
              className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-1000"
            />
             <div className="absolute inset-0 bg-[#a41018]/10 group-hover:bg-[#a41018]/0 transition-colors duration-500"></div>
          </div>
        </FadeInSection>
        
        <FadeInSection delay={200}>
          <div className="space-y-6">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900">Biz Kimiz?</h2>
            <div className="w-16 h-1 bg-[#a41018] rounded-full"></div>
            <p className="text-gray-600 text-lg leading-relaxed">
              AA Yazılım olarak, teknolojiyi sadece bir araç olarak değil, işinizi büyüten en güçlü ortak olarak görüyoruz. İstanbul merkezli ekibimizle, Türkiye'den dünyaya açılan projeler geliştiriyoruz.
            </p>
            <p className="text-gray-600 leading-relaxed">
              Yılların verdiği deneyimle, karmaşık problemleri basit ve etkili çözümlere dönüştürüyoruz.
            </p>
            
            <div className="grid grid-cols-2 gap-4 mt-4">
              <div className="flex items-center gap-3">
                <Icons.CheckCircle className="text-[#a41018]" />
                <span className="text-gray-800 font-medium">Yenilikçi Yaklaşım</span>
              </div>
              <div className="flex items-center gap-3">
                <Icons.CheckCircle className="text-[#a41018]" />
                <span className="text-gray-800 font-medium">Uzman Kadro</span>
              </div>
              <div className="flex items-center gap-3">
                <Icons.CheckCircle className="text-[#a41018]" />
                <span className="text-gray-800 font-medium">Küresel Standartlar</span>
              </div>
              <div className="flex items-center gap-3">
                <Icons.CheckCircle className="text-[#a41018]" />
                <span className="text-gray-800 font-medium">Zamanında Teslim</span>
              </div>
            </div>
          </div>
        </FadeInSection>
      </div>
    </section>
  );
};

const Services = () => {
  const services = [
  { 
    id: "01",
    icon: <Icons.Code size={32} />, 
    title: "Web Geliştirme", 
    desc: "Markanızın dijital yüzünü en iyi şekilde yansıtan, yüksek performanslı ve SEO uyumlu web mimarileri.",
    // Eski: ["React", "Next.js", "Kurumsal"]
    // Yeni: SEO odaklı, Teknoloji ve İş Türü
    tags: ["SEO Uyumlu", "E-Ticaret / Kurumsal", "React & Next.js"]
  },
  { 
    id: "02",
    icon: <Icons.Smartphone size={32} />, 
    title: "Mobil Uygulama", 
    desc: "Kullanıcı alışkanlıklarına uygun, iOS ve Android platformlarında çalışan akıcı native mobil deneyimler.",
    // Eski: ["Flutter", "Swift", "Kotlin"]
    // Yeni: Platform kapsayıcılığı ve performans vurgusu
    tags: ["iOS & Android", "Cross-Platform", "Yüksek Performans"]
  },
  { 
    id: "03",
    icon: <Icons.ShieldCheck size={32} />, 
    title: "Siber Güvenlik", 
    desc: "Veri ihlallerini önleyen proaktif savunma sistemleri, sızma testleri ve 7/24 güvenlik duvarı yönetimi.",
    // Eski: ["Penetration", "Firewall", "Analiz"]
    // Yeni: Hizmet adı, Yasal uyumluluk ve Koruma tipi
    tags: ["Sızma Testi (Pentest)", "KVKK / GDPR", "Ağ Güvenliği"]
  },
  { 
    id: "04",
    icon: <Icons.Cpu size={32} />, 
    title: "Yapay Zeka", 
    desc: "Büyük veriyi anlamlı içgörülere dönüştüren makine öğrenimi modelleri ve süreç otomasyonları.",
    // Eski: ["ML", "NLP", "Otomasyon"]
    // Yeni: Veri büyüklüğü, Uygulama alanı ve Sonuç
    tags: ["Büyük Veri (Big Data)", "Chatbot & Asistan", "Tahminleme"]
  },
  { 
    id: "05",
    icon: <Icons.Network size={32} />, 
    title: "IoT Çözümleri", 
    desc: "Fiziksel dünyayı dijitalle buluşturan, uzaktan izlenebilir akıllı cihaz ekosistemleri.",
    // Eski: ["Smart Home", "Endüstri 4.0"]
    // Yeni: Donanım, İletişim protokolü ve İşlev
    tags: ["Akıllı Sensörler", "M2M İletişim", "Uzaktan Kontrol"]
  },
  { 
    id: "06",
    icon: <Icons.Palette size={32} />, 
    title: "UI/UX Tasarım", 
    desc: "Kullanıcı psikolojisine hitap eden, etkileşimi artıran modern ve estetik arayüz tasarımları.",
    // Eski: ["Figma", "Prototip", "User Flow"]
    // Yeni: Süreç, Çıktı ve Tasarım Felsefesi
    tags: ["Kullanıcı Araştırması", "Wireframe & Prototip", "Mobil Öncelikli"]
  },
];

  return (
    <section id="services" className="py-24 bg-gray-50 relative overflow-hidden">
      {/* Arka Plan Dekoratif Desenler */}
      <div className="absolute inset-0 pointer-events-none opacity-[0.03]" 
           style={{ backgroundImage: 'radial-gradient(#a41018 1px, transparent 1px)', backgroundSize: '32px 32px' }}>
      </div>
      
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-red-100/40 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-gray-200/40 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2"></div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-6">
          <FadeInSection>
            <div>
              <span className="text-[#a41018] font-bold tracking-wider uppercase text-sm mb-2 block">Uzmanlık Alanlarımız</span>
              <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight">
                Dijital Dünyada <br/>
                <span className="relative inline-block">
                  Sınırları Zorluyoruz
                  <span className="absolute bottom-1 left-0 w-full h-3 bg-[#a41018]/10 -z-10 skew-x-12"></span>
                </span>
              </h2>
            </div>
          </FadeInSection>
          
          <FadeInSection delay={100}>
            <p className="text-gray-600 max-w-md text-lg leading-relaxed md:text-right">
              İşletmenizi bir sonraki seviyeye taşıyacak teknolojik altyapıyı, estetik ve güvenlikle birleştiriyoruz.
            </p>
          </FadeInSection>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <FadeInSection key={index} delay={index * 100}>
              <div className="group relative bg-white rounded-[2rem] p-8 h-full border border-gray-100 shadow-sm hover:shadow-2xl hover:shadow-red-900/5 transition-all duration-500 flex flex-col overflow-hidden">
                
                {/* Kart Hover Efekti - Arka Plan Gradient */}
                <div className="absolute inset-0 bg-gradient-to-br from-white via-white to-red-50 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                
                {/* Üst Kısım: İkon ve Numara */}
                <div className="relative flex justify-between items-start mb-8">
                  <div className="w-16 h-16 rounded-2xl bg-gray-50 flex items-center justify-center text-gray-700 group-hover:bg-[#a41018] group-hover:text-white transition-all duration-300 transform group-hover:scale-110 group-hover:rotate-3 shadow-sm">
                    {service.icon}
                  </div>
                  <span className="text-4xl font-extrabold text-gray-100 group-hover:text-red-100/50 transition-colors duration-300 select-none">
                    {service.id}
                  </span>
                </div>

                {/* İçerik */}
                <div className="relative flex-grow">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-[#a41018] transition-colors duration-300">
                    {service.title}
                  </h3>
                  <p className="text-gray-500 leading-relaxed mb-6 group-hover:text-gray-600">
                    {service.desc}
                  </p>
                </div>

                {/* Alt Kısım: Etiketler ve Ok */}
                <div className="relative mt-auto pt-6 border-t border-gray-100 group-hover:border-red-100 transition-colors flex justify-between items-center">
                  <div className="flex flex-wrap gap-2">
                    {service.tags.map((tag, i) => (
                      <span key={i} className="text-xs font-medium px-2.5 py-1 rounded-md bg-gray-50 text-gray-500 group-hover:bg-white group-hover:text-[#a41018] group-hover:shadow-sm transition-all">
                        #{tag}
                      </span>
                    ))}
                  </div>
                  
                  <div className="w-10 h-10 rounded-full border border-gray-200 flex items-center justify-center text-gray-400 group-hover:border-[#a41018] group-hover:bg-[#a41018] group-hover:text-white transition-all duration-300 transform translate-x-0 group-hover:translate-x-1">
                    <Icons.ArrowRight size={18} />
                  </div>
                </div>

              </div>
            </FadeInSection>
          ))}
        </div>
      </div>
    </section>
  );
};

const WhyUs = () => {
  const features = [
    { icon: <Icons.Target className="text-[#a41018]" />, title: "Sonuç Odaklı Stratejiler" },
    { icon: <Icons.Zap className="text-[#a41018]" />, title: "Hızlı ve Çevik Geliştirme" },
    { icon: <Icons.Users className="text-[#a41018]" />, title: "Alanında Uzman Kadro" },
    { icon: <Icons.Headset className="text-[#a41018]" />, title: "Kesintisiz Destek" },
    { icon: <Icons.Lock className="text-[#a41018]" />, title: "Üst Düzey Veri Güvenliği" },
    { icon: <Icons.CheckCircle className="text-[#a41018]" />, title: "%100 Kalite Garantisi" },
  ];

  return (
    <section id="why-us" className="py-24 bg-white relative overflow-hidden">
      <div className="container mx-auto px-6 grid lg:grid-cols-2 gap-20 items-center">
        <div className="order-2 lg:order-1 relative">
          <FadeInSection>
            <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl border-4 border-white group">
               <img 
                 src="https://images.unsplash.com/photo-1552664730-d307ca884978?q=80&w=2070&auto=format&fit=crop" 
                 alt="Strategy Meeting" 
                 className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-1000"
               />
            </div>
            <div className="absolute -bottom-10 -left-10 w-40 h-40 opacity-20 bg-[radial-gradient(#a41018_2px,transparent_2px)] [background-size:16px_16px]"></div>
          </FadeInSection>
        </div>

        <div className="order-1 lg:order-2">
          <FadeInSection>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">Neden Bizi Seçmelisiniz?</h2>
            <p className="text-gray-600 mb-8 text-lg leading-relaxed">
              Sadece kod yazmıyoruz; işletmenizin dijital geleceğini inşa ediyoruz. Teknolojinin en son imkanlarını kullanarak size rekabet avantajı sağlıyoruz.
            </p>
            
            <div className="grid sm:grid-cols-2 gap-x-6 gap-y-8">
              {features.map((feature, idx) => (
                <div key={idx} className="flex items-start gap-4 p-2 rounded-lg hover:bg-gray-50 transition-colors duration-300">
                  <div className="p-2 bg-red-50 rounded-lg shrink-0">
                    {feature.icon}
                  </div>
                  <span className="text-gray-800 font-semibold mt-1">{feature.title}</span>
                </div>
              ))}
            </div>
          </FadeInSection>
        </div>
      </div>
    </section>
  );
};

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [animDirection, setAnimDirection] = useState('up'); 

  const testimonials = [
    {
      text: "AA Yazılım ile çalışmak işimiz için oyunun kurallarını değiştirdi. Yapay zeka çözümleri operasyonlarımızı kolaylaştırdı ve beklentilerimizin ötesinde verimlilik sağladı.",
      author: "Hafize Ürüşan",
      role: "E-Ticaret Direktörü",
      image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=200&auto=format&fit=crop"
    },
    {
      text: "Siber güvenlik konusundaki endişelerimizi tamamen ortadan kaldırdılar. Profesyonel yaklaşımları sayesinde verilerimiz artık tamamen güvende.",
      author: "Murat Yılmaz",
      role: "CTO, FinansTech",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?q=80&w=200&auto=format&fit=crop"
    },
    {
      text: "Mobil uygulamamızın tasarım ve yazılım sürecini mükemmel yönettiler. Kullanıcı deneyimi harika olan bir ürün ortaya çıktı.",
      author: "Selin Demir",
      role: "Pazarlama Müdürü",
      image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?q=80&w=200&auto=format&fit=crop"
    }
  ];

  const nextTestimonial = () => {
    setAnimDirection('up'); 
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setAnimDirection('down'); 
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="testimonials" className="py-24 bg-white overflow-hidden">
      <div className="container mx-auto px-6 relative">
        <FadeInSection>
          <div className="grid md:grid-cols-2 gap-12 lg:gap-24 relative items-center">
            
            <div className="pr-4 md:pr-8 text-left">
              <h2 className="text-4xl lg:text-5xl font-extrabold text-[#111827] leading-tight mb-6">
                Müşterilerimiz <br />
                <span className="text-[#a41018]">Bizim İçin Ne Diyor?</span>
              </h2>
              <p className="text-gray-600 text-lg leading-relaxed">
                Müşterilerimiz, gerçek sonuçlar doğuran son teknoloji AI ve yazılım çözümleri sunma konusunda bize güveniyor. İşletmenizi büyütmek için buradayız.
              </p>
            </div>

            <div className="hidden md:flex absolute left-1/2 top-0 bottom-0 -translate-x-1/2 flex-col justify-center items-center z-10">
              <div className="w-px h-full bg-gray-200 absolute top-0"></div>
              <div className="flex flex-col gap-4 relative z-20 bg-white py-4">
                <button 
                  onClick={prevTestimonial}
                  className="w-12 h-12 rounded-full border border-gray-200 bg-white text-gray-400 hover:text-[#a41018] hover:border-[#a41018] flex items-center justify-center transition-all shadow-sm hover:shadow-md"
                >
                  <Icons.ArrowLeft size={20} className="rotate-90 md:rotate-0" />
                </button>
                <button 
                  onClick={nextTestimonial}
                  className="w-12 h-12 rounded-full border border-gray-200 bg-white text-gray-400 hover:text-[#a41018] hover:border-[#a41018] flex items-center justify-center transition-all shadow-sm hover:shadow-md"
                >
                  <Icons.ArrowRight size={20} />
                </button>
              </div>
            </div>

            <div className="md:hidden flex justify-end gap-4 mb-4">
                <button onClick={prevTestimonial} className="w-10 h-10 rounded-full border border-gray-200 flex items-center justify-center"><Icons.ArrowLeft size={18} /></button>
                <button onClick={nextTestimonial} className="w-10 h-10 rounded-full border border-gray-200 flex items-center justify-center"><Icons.ArrowRight size={18} /></button>
            </div>

            <div className="pl-0 md:pl-8 lg:pl-12 flex flex-col justify-center relative h-[450px]"> 
              <div 
                key={currentIndex} 
                className={`absolute inset-0 flex flex-col justify-center transition-all duration-500 ${
                   animDirection === 'up' ? 'animate-slide-up' : 'animate-slide-down'
                }`}
              >
                <span className="inline-block px-4 py-1.5 bg-red-50 text-[#a41018] text-xs font-bold uppercase tracking-wider rounded-full mb-6 w-fit">
                  Referanslar
                </span>
                
                <div className="text-[#a41018] mb-6">
                  <Icons.QuoteSolid size={48} />
                </div>

                <p className="text-xl text-gray-600 leading-relaxed mb-8">
                  "{testimonials[currentIndex].text}"
                </p>

                <div className="flex items-center gap-4">
                  <img 
                    src={testimonials[currentIndex].image} 
                    alt={testimonials[currentIndex].author} 
                    className="w-16 h-16 rounded-full object-cover border-2 border-white shadow-md"
                  />
                  <div>
                    <h4 className="text-[#111827] font-bold text-lg">{testimonials[currentIndex].author}</h4>
                    <p className="text-gray-500 text-sm">{testimonials[currentIndex].role}</p>
                  </div>
                </div>

                <div className="flex gap-2 mt-8">
                  {testimonials.map((_, idx) => (
                    <button 
                      key={idx} 
                      onClick={() => setCurrentIndex(idx)}
                      className={`h-3 rounded-full transition-all duration-300 ${idx === currentIndex ? 'w-8 bg-[#a41018]' : 'w-3 bg-gray-300 hover:bg-gray-400'}`}
                      aria-label={`Go to slide ${idx + 1}`}
                    />
                  ))}
                </div>
              </div>
            </div>

          </div>
        </FadeInSection>
      </div>
    </section>
  );
};

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    lastname: '',
    email: '',
    message: ''
  });
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    try {
      const response = await fetch('http://localhost:5000/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: `${formData.name} ${formData.lastname}`,
          email: formData.email,
          message: formData.message
        })
      });
      const data = await response.json();
      if (response.ok) {
        setStatus('success');
        setFormData({ name: '', lastname: '', email: '', message: '' });
      } else {
        throw new Error(data.message || 'Bir hata oluştu.');
      }
    } catch (error) {
      setStatus('error');
      console.error('Gönderme hatası:', error);
    }
  };


  return (
    <section id="contact-area" className="py-24 bg-white relative overflow-hidden">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-red-50/50 rounded-full blur-3xl -z-10"></div>

      <div className="container mx-auto px-6 grid lg:grid-cols-2 gap-16 items-center">
        <FadeInSection>
          <div className="relative">
             <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl border-4 border-white group">
                <img 
                  src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?q=80&w=2070&auto=format&fit=crop" 
                  alt="Contact Team" 
                  className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-1000"
                />
             </div>
             <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-[#a41018]/10 rounded-full blur-xl"></div>
             <div className="absolute -top-6 -right-6 w-32 h-32 bg-red-400/10 rounded-full blur-xl"></div>
          </div>
        </FadeInSection>

        <FadeInSection delay={200}>
          <div className="pl-0 lg:pl-8">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Bize Ulaşın</h2>
            <p className="text-gray-600 mb-8 text-lg">
              Projeleriniz veya sorularınız için formu doldurun, ekibimiz en kısa sürede iletişime geçsin.
            </p>

            <form onSubmit={handleSubmit} className="space-y-5">
              <div className="grid grid-cols-2 gap-5">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Adınız</label>
                  <input type="text" name="name" value={formData.name} onChange={handleChange} className="w-full bg-gray-50 border border-gray-200 rounded-xl p-4 text-gray-900 focus:bg-white focus:border-[#a41018] focus:ring-4 focus:ring-[#a41018]/10 focus:outline-none transition-all duration-300" placeholder="Adınız" required/>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Soyadınız</label>
                  <input type="text" name="lastname" value={formData.lastname} onChange={handleChange} className="w-full bg-gray-50 border border-gray-200 rounded-xl p-4 text-gray-900 focus:bg-white focus:border-[#a41018] focus:ring-4 focus:ring-[#a41018]/10 focus:outline-none transition-all duration-300" placeholder="Soyadınız" required/>
                </div>
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">E-posta</label>
                <input type="email" name="email" value={formData.email} onChange={handleChange} className="w-full bg-gray-50 border border-gray-200 rounded-xl p-4 text-gray-900 focus:bg-white focus:border-[#a41018] focus:ring-4 focus:ring-[#a41018]/10 focus:outline-none transition-all duration-300" placeholder="ornek@sirket.com" required/>
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Mesajınız</label>
                <textarea rows="4" name="message" value={formData.message} onChange={handleChange} className="w-full bg-gray-50 border border-gray-200 rounded-xl p-4 text-gray-900 focus:bg-white focus:border-[#a41018] focus:ring-4 focus:ring-[#a41018]/10 focus:outline-none transition-all duration-300 resize-none" placeholder="Projenizden bahsedin..." required></textarea>
              </div>
              <button type="submit" className="w-full bg-[#a41018] hover:bg-[#8a0d14] text-white font-bold py-4 rounded-xl shadow-lg shadow-red-500/20 hover:shadow-red-500/40 transition-all duration-300 flex items-center justify-center gap-2 group transform hover:-translate-y-1" disabled={status === 'sending'}>
                {status === 'sending' ? (
                  <span>Gönderiliyor...</span>
                ) : (
                  <>
                  <span>Mesajı Gönder</span>
                  <Icons.ArrowRight size={20} className="transform group-hover:translate-x-1 transition-transform" />
                  </>
                )}
              </button>
              {status === 'success' && <p className="text-green-600">Mesajınız başarıyla gönderildi!</p>}
              {status === 'error' && <p className="text-red-600">Mesaj gönderilirken bir hata oluştu.</p>}
            </form>
          </div>
        </FadeInSection>
      </div>
    </section>
  );
};

const Footer = () => {
  const socialLinks = [
    { icon: Icons.Facebook, href: "#" },
    { icon: Icons.Twitter, href: "#" },
    { icon: Icons.Instagram, href: "https://www.instagram.com/aayazilim_/" }, 
    { icon: Icons.Linkedin, href: "#" }
  ];

  return (
    <footer className="bg-[#0B0C15] pt-24 pb-12 text-gray-400 border-t border-white/10 relative overflow-hidden font-sans">
      
      <div 
        className="absolute inset-0 z-0 pointer-events-none"
        style={{
          background: `
            radial-gradient(circle at 10% 20%, rgba(164, 16, 24, 0.08), transparent 40%),
            radial-gradient(circle at 90% 80%, rgba(164, 16, 24, 0.05), transparent 40%)
          `
        }}
      ></div>

      <div 
        className="absolute inset-0 z-0 opacity-20 pointer-events-none"
        style={{
          backgroundImage: 'radial-gradient(circle, #64748b 1px, transparent 1px)',
          backgroundSize: '24px 24px', 
          maskImage: 'radial-gradient(circle at center, black, transparent 90%)'
        }}
      ></div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-16 mb-20">
          
          <div className="space-y-6">
            <div className="mb-6">
               <img src={desktopLogo} alt="AA Yazılım" className="h-12 w-auto object-contain" />
            </div>
            
            <p className="text-sm leading-7 text-gray-400">
              AA Yazılım, yapay zeka, makine öğrenimi ve süreç otomasyonu alanlarında yenilikçi ve son teknoloji çözümler sunmaya kendini adamıştır.
            </p>
            
            <div className="flex space-x-3 pt-2">
              {socialLinks.map((item, idx) => (
                 <a 
                   key={idx} 
                   href={item.href} 
                   target="_blank" 
                   rel="noopener noreferrer"
                   className="w-10 h-10 rounded-xl bg-white/5 border border-white/5 flex items-center justify-center text-gray-400 hover:bg-[#a41018] hover:border-[#a41018] hover:text-white transition-all duration-300 group"
                 >
                   <item.icon size={18} className="group-hover:scale-110 transition-transform" />
                 </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-white font-bold mb-8 text-lg relative inline-block">
              İletişim
              <span className="absolute -bottom-2 left-0 w-12 h-1 bg-[#a41018] rounded-full"></span>
            </h4>
            <div className="space-y-6">
              
              <div className="flex gap-4 items-start group">
                <div className="mt-1 p-2 rounded-lg bg-white/5 group-hover:bg-[#a41018]/20 transition-colors">
                  <Icons.MapPin className="text-gray-400 group-hover:text-[#a41018] transition-colors" size={20} />
                </div>
                <div>
                  <h5 className="text-white font-semibold text-sm mb-1">Türkiye Ofisi</h5>
                  <p className="text-sm text-gray-400 leading-relaxed">
                    İstanbul Teknik Üniversitesi<br/>
                    Reşitpaşa Mah. Katar Cad.<br/>
                    ARI-1, Sarıyer / İSTANBUL
                  </p>
                </div>
              </div>

              <div className="flex gap-4 items-center group">
                <div className="p-2 rounded-lg bg-white/5 group-hover:bg-[#a41018]/20 transition-colors">
                  <Icons.Phone className="text-gray-400 group-hover:text-[#a41018] transition-colors" size={20} />
                </div>
                <span className="text-sm text-gray-400 group-hover:text-white transition-colors">+90 530 416 2355</span>
              </div>

              <div className="flex gap-4 items-center group">
                <div className="p-2 rounded-lg bg-white/5 group-hover:bg-[#a41018]/20 transition-colors">
                  <Icons.Mail className="text-gray-400 group-hover:text-[#a41018] transition-colors" size={20} />
                </div>
                <span className="text-sm text-gray-400 group-hover:text-white transition-colors">info@aayazilim.com</span>
              </div>

            </div>
          </div>

          <div>
            <h4 className="text-white font-bold mb-8 text-lg relative inline-block">
              Hızlı Linkler
              <span className="absolute -bottom-2 left-0 w-12 h-1 bg-[#a41018] rounded-full"></span>
            </h4>
            <ul className="space-y-3">
              {['Hakkımızda', 'Vizyon & Misyon', 'Ekibimiz', 'Kariyer', 'Gizlilik Politikası', 'S.S.S'].map((item) => (
                <li key={item}>
                  <a href="#" className="flex items-center gap-3 text-sm text-gray-400 hover:text-white transition-all group">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#a41018] opacity-0 group-hover:opacity-100 transition-opacity"></span>
                    <span className="group-hover:translate-x-1 transition-transform">{item}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-8 text-lg relative inline-block">
              Hizmetlerimiz
              <span className="absolute -bottom-2 left-0 w-12 h-1 bg-[#a41018] rounded-full"></span>
            </h4>
            <ul className="space-y-3">
              {['Yapay Zeka Danışmanlığı', 'Özel Yazılım Geliştirme', 'Dijital Dönüşüm', 'Makine Öğrenimi', 'Veri Analizi', 'Siber Güvenlik'].map((item) => (
                <li key={item}>
                  <a href="#" className="flex items-center gap-3 text-sm text-gray-400 hover:text-white transition-all group">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#a41018] opacity-0 group-hover:opacity-100 transition-opacity"></span>
                    <span className="group-hover:translate-x-1 transition-transform">{item}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center text-gray-500 text-xs gap-4">
          <p>&copy; 2025 AA Yazılım. Tüm hakları saklıdır.</p>
          <div className="flex space-x-8">
            <a href="#" className="hover:text-[#a41018] transition-colors">Kullanım Şartları</a>
            <a href="#" className="hover:text-[#a41018] transition-colors">Gizlilik Politikası</a>
            <a href="#" className="hover:text-[#a41018] transition-colors">Çerez Politikası</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default function App() {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const checkScroll = () => {
      setShowScrollTop(window.scrollY > 400);
    };
    window.addEventListener('scroll', checkScroll);
    return () => window.removeEventListener('scroll', checkScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  
  const scrollToContact = () => {
    const section = document.getElementById('contact-area');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="font-sans bg-white min-h-screen text-gray-900 selection:bg-[#a41018] selection:text-white">
      <Navbar scrollToContact={scrollToContact} />
      
      <main>
        <Hero scrollToContact={scrollToContact} />
        <Stats />
        <AboutUs />
        <Services />
        <WhyUs />
        <Testimonials />
        <ContactSection />
      </main>

      <Footer />
      
      {/* Scroll to Top Button - Kırmızı */}
      <button
        onClick={scrollToTop}
        className={`fixed bottom-8 right-8 w-12 h-12 bg-[#a41018] text-white rounded-full shadow-lg z-40 transition-all duration-300 flex items-center justify-center hover:-translate-y-1 hover:shadow-xl ${
          showScrollTop ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'
        }`}
        aria-label="Go to top"
      >
        <Icons.ChevronUp size={24} strokeWidth={2.5} />
      </button>

      {/* WhatsApp Button - Yeşil Kalmalı (Standart) */}
      <a
        href="https://wa.me/905304162355"
        target="_blank"
        rel="noopener noreferrer"
        className={`fixed right-8 w-12 h-12 bg-[#25D366] text-white rounded-full shadow-lg z-50 transition-all duration-300 hover:scale-110 flex items-center justify-center hover:shadow-green-500/30 shadow-green-500/20 ${
          showScrollTop ? 'bottom-[5.5rem]' : 'bottom-8'
        }`}
        aria-label="WhatsApp"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="white" className="bi bi-whatsapp" viewBox="0 0 16 16">
          <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
        </svg>
      </a>
      
      <style>{`
        @keyframes bounce-slow {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-15px); }
        }
        @keyframes slideInFromBottom {
          from { opacity: 0; transform: translateY(50px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes slideInFromTop {
          from { opacity: 0; transform: translateY(-50px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-slide-up {
          animation: slideInFromBottom 0.5s ease-out forwards;
        }
        .animate-slide-down {
          animation: slideInFromTop 0.5s ease-out forwards;
        }
        .animate-bounce-slow {
          animation: bounce-slow 4s infinite ease-in-out;
        }
        .animate-fade-in-up {
          animation: fadeInUp 0.4s ease-out forwards;
        }
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in {
            animation: fadeIn 1s ease-out forwards;
        }
        @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
        }
        html { scroll-behavior: smooth; }
      `}</style>
    </div>
  );
}